import React from "react";

// Project Imports
import WithLayout from "../../../components/WithLayout";
import Admin from "../../../layouts/Admin";
import AddTourScreen from "../../../views/Admin/AddTourScreen";

// ===================Add Tour Plan Page ================= //
const Tour = () => {
  return <WithLayout layout={Admin} component={AddTourScreen} />;
};

export default Tour;
